import { copy } from '@/clipboard'

document.addEventListener('DOMContentLoaded', () => {
  if (document.body.clientWidth < 768) {
    const footer = document.querySelector(
      '[data-scope-path="layouts/_footer"]'
    ) as HTMLElement
    footer.style.marginBottom = '50px'
  }
  const shareUrl = location.href
  const shareTitle = document.title
  const rssUrl = 'https://ferret-plus.com/.rss'
  const windowOption =
    'width=650, height=450, menubar=no, toolbar=no, scrollbars=yes'

  const showCopiedFeedback = (button: HTMLElement) => {
    const name = 'clicked'
    button.classList.add(name)
    setTimeout(() => {
      button.classList.remove(name)
    }, 1500)
  }

  const actions = {
    twitter() {
      const url = `//twitter.com/share?text=${shareTitle}&url=${shareUrl}&via=ferretplus`
      window.open(url, 'ShareWindow', windowOption)
    },
    facebook() {
      const url = `//www.facebook.com/sharer.php?ref=plugin&u=${shareUrl}`
      window.open(url, 'ShareWindow', windowOption)
    },
    hatena() {
      const url = `//b.hatena.ne.jp/add?mode=confirm&url=${shareUrl}&title=${shareTitle}`
      window.open(url, 'ShareWindow', windowOption)
    },
    rss(button: HTMLElement) {
      copy(rssUrl)
      showCopiedFeedback(button)
    },
    link(button: HTMLElement) {
      copy(shareUrl)
      showCopiedFeedback(button)
    }
  }

  document
    .querySelectorAll('.js-sns-share-action-button')
    .forEach((button: HTMLElement) => {
      button.addEventListener('click', () => {
        actions[button.dataset.type](button)
      })
    })
})
